import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

/**
 * Header for the campaign section that provides UI controls to create a new campaign and navigate to the campaign editor.
 * Purpose: Displays campaign heading/actions and handles user intent to create a new campaign by performing router navigation.
 * Key methods:
 *   - onCreateCampaign(): Navigates to '/campaign-editor' with queryParams { new: 'true' } to initiate a new campaign workflow.
 * Dependencies:
 *   - Injects Angular Router to perform navigation operations.
 * Lifecycle:
 *   - No Angular lifecycle hooks (ngOnInit, ngOnDestroy, etc.) are implemented on this component.
 * @component
 * @selector app-campaign-header
 * @example
 *   <app-campaign-header></app-campaign-header>
 * @input N/A none - This component does not expose any @Input properties.
 * @output N/A none - This component does not emit any @Output events.
 */
@Component({
  selector: 'app-campaign-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './campaign-header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './campaign-header.component.scss',
})
export class CampaignHeaderComponent {
  constructor(private router: Router) {}

  onCreateCampaign(): void {
    this.router.navigate(['/campaign-editor'], {
      queryParams: { new: 'true' },
    });
  }
}
